import { lazy } from 'react';
import { RoleBasedGuard } from 'src/auth/guard';
import { ROLES } from 'src/constants';

// ----------------------------------------------------------------------

const HomeEdFamiliesPage = lazy(() => import('src/pages/home-ed/families'));
const HomeEdFamilyDetailPage = lazy(() => import('src/pages/home-ed/family-detail'));

// ----------------------------------------------------------------------

const guardedList = (
  <RoleBasedGuard navigateTo roles={[ROLES.HOMESCHOOL_ADMIN]}>
    <HomeEdFamiliesPage />
  </RoleBasedGuard>
);

const guardedDetail = (
  <RoleBasedGuard navigateTo roles={[ROLES.HOMESCHOOL_ADMIN, ROLES.HOMESCHOOL_FACILITATOR]}>
    <HomeEdFamilyDetailPage />
  </RoleBasedGuard>
);

export const homeEdFamiliesRoutes = [
  {
    path: 'home-ed-families',
    children: [
      { element: guardedList, index: true },
      { path: ':id', element: guardedDetail },
    ],
  },
];
